
import styles from "../../../../AccountingPage.module.scss";
import { useEffect, useState } from 'react'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getStudentsHistoryPayData, PatchPaymentData, DeletePaymentData } from "service/AccountingService";
import Notification from "utils/Notifications";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import ContractOrder from "./components/ContractOrder"
const StudentHystoryPayContent = ({ render, setRender, id, datastudent }) => {
  const componentRef = useRef();
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const [openModalOrder, setOpenModalOrder] = useState(false);

  const [item_data, setItemData] = useState([]);
  const setOpenModalOrderFun = (item) => {
    setOpenModalOrder(true);
    setItemData(item);
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [datahistory, setDataHistory] = useState([]);
  const getDataHistory = async (id) => {
    try {
      let response = await getStudentsHistoryPayData(id, datahistory);
      setDataHistory(response.data);
    } catch (error) {
      console.log("onoxo")
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(datahistory.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = datahistory.slice(indexOfFirstItem, indexOfLastItem);
  useEffect(() => {
    getDataHistory(id)
    setRender(false);

    // getData(id);


  }, [render]);
  const [editPaymentRowId, setEditPaymentRowId] = useState(null);
  const [editPaymentOrder, setEditPaymentOrder] = useState("");
  const [editPaymentAmount, setEditPaymentAmount] = useState("");
  const [editPaymentBase, setEditPaymentBase] = useState("");
  const [editPaymentDate, setEditPaymentDate] = useState("");
  const handleEditPayment = (item) => {
    setEditPaymentRowId(item.id);
    setEditPaymentOrder(item.order);
    setEditPaymentAmount(item.amount);
    setEditPaymentBase(item.base);
  };

  const onDelete = async (id) => {
    let data = await DeletePaymentData(id);
    setNotify({
      isOpen: true,
      message: "Оплата успешно удалена!",
      type: "success",
      sound: "success"
    });
    setEditPaymentRowId(null);
    setRender(true)
  };
  const handleSavePayment = async (id) => {
    const formData = new FormData();
    formData.append("order", editPaymentOrder);
    formData.append("amount", editPaymentAmount);
    formData.append("base", editPaymentBase);

    if (editPaymentDate) {
      formData.append('date', editPaymentDate);
    }
    const response = await PatchPaymentData(id, formData); // твой API


    setNotify({
      isOpen: true,
      message: "Платёж успешно обновлён!",
      type: "success",
      sound: "success"
    });
    setRender(true);
    setEditPaymentRowId(null);

  };

  return (
    <>

      <div className={styles.content_header} style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ width: "100%" }} className={styles.print_header_selection_shah}>
          <table className={styles.table__wrapper}>
            <thead className={styles.table__head}>
              <tr className={styles.table__row}>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>ИНН</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Фамилия</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Имя</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Специальность</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Вид обучения</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Дата и время</span>
                </th>
              </tr>
            </thead>
            <tbody className={styles.table__body}>
              <tr className={styles.table__row}>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.inn}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.surname}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.first_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.speciality_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.educationtype_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>
                    {new Date().toLocaleString("ru-RU", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className={styles.project__h}>История оплат</h3>
          <hr style={{ borderTop: '2px solid #444', margin: '20px 0 0 0' }} />
        </div>



        <table ref={componentRef} className={styles.table__wrapper}>
          <thead className={styles.table__head}>
            <tr className={styles.table__row}>
              <th className={styles.table__item_student}>№</th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Курс</span>
              </th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Ордер </span>
              </th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Сумма </span>
              </th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Основание </span>
              </th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Дата платежа </span>
              </th>
              <th className={styles.table__item_student}>
                <span className={styles.table__title}>Дата создания </span>
              </th>
            </tr>
          </thead>

          <tbody className={styles.table__body}>
            {currentItems.map((item, index) => (

              <tr className={styles.table__row} key={item.id}>
                <td className={styles.table__item_student}>
                  <span className={styles.table__title}>
                    {index + 1 + (currentPage - 1) * itemsPerPage}
                  </span>
                </td>

                {editPaymentRowId === item.id ? (
                  <>
                    <td className={styles.table__item_student}>
                      <span className={styles.table__title}>{item.course_name}</span>
                    </td>
                    <td className={styles.table__item_student}>
                      <input
                        type="text"
                        value={editPaymentOrder}
                        onChange={(e) => setEditPaymentOrder(e.target.value)}
                        className={styles.edit_input}
                      />
                    </td>
                    <td className={styles.table__item_student}>
                      <input
                        type="number"
                        value={editPaymentAmount}
                        onChange={(e) => setEditPaymentAmount(e.target.value)}
                        className={styles.edit_input}
                      />
                    </td>
                    <td className={styles.table__item_student}>
                      <select
                        value={editPaymentBase}
                        onChange={(e) => setEditPaymentBase(e.target.value)}
                        className={styles.edit_input}
                      >
                        <option value="Оплата за обучение">Оплата за обучение</option>
                        <option value="Предоплата">Предоплата</option>
                        <option value="Оформление документа">Оформление документа</option>
                        <option value="За разницу">За разницу</option>
                        <option value="За восстановление">За восстановление</option>
                      </select>
                    </td>
                    <td className={styles.table__item_student}>
                      <input
                        type="date"
                        value={editPaymentDate}
                        onChange={(e) => setEditPaymentDate(e.target.value)}
                        className={styles.edit_input}
                      />
                    </td>
                    <td className={styles.table__item_student}>
                      <div className={styles.table__item__div}>
                        <button
                          onClick={() => handleSavePayment(item.id)}
                          className={styles.saveBtn}
                        >
                          💾
                        </button>
                        <button
                          onClick={() => setEditPaymentRowId(null)}
                          className={styles.cancelBtn}
                        >
                          ❌
                        </button>
                        <button onClick={() => onDelete(item.id)} className={styles.deleteBtn}>🗑️</button>
                      </div>
                    </td>
                  </>
                ) : (
                  <>
                    <td className={styles.table__item_student}>
                      <span className={styles.table__title} style={{ fontWeight: "700" }}>
                        {item.course_name}
                      </span>
                    </td>
                    <td className={styles.table__item_student}>
                      <span className={styles.table__title} style={{ fontWeight: "700" }}>
                        {item.order}
                      </span>
                    </td>
                    <td className={styles.table__item_student}>
                      <span className={styles.table__title} style={{ fontWeight: "700" }}>
                        {item.amount}
                      </span>
                    </td>
                    <td className={styles.table__item_student}>
                      <span className={styles.table__title} style={{ fontWeight: "700" }}>
                        {item.base}
                      </span>
                    </td>
                    <td className={styles.table__item_student}>
                      <span className={styles.table__title} style={{ fontWeight: "700" }}>
                        {item.date}
                      </span>
                    </td>
                    <td className={styles.table__item_student}>
                      <div className={styles.table__item__div}>
                        <button
                          onClick={() => handleEditPayment(item)}
                          className={styles.editBtn}
                        >
                          ✏️
                        </button>
                        <button onClick={() => setOpenModalOrderFun(item)} className={styles.editBtn}>🖨️</button>
                      </div>
                    </td>
                  </>
                )}
              </tr>

            ))}

            {/* Итого */}

          </tbody>
          <div className={styles.pagination}>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                style={{
                  padding: '5px 10px',
                  background: currentPage === page ? '#736CED' : '#f0f0f0',
                  color: currentPage === page ? '#fff' : '#000',
                  border: '1px solid #ccc',
                  borderRadius: "6px",
                  cursor: 'pointer',
                }}
              >
                {page}
              </button>
            ))}
          </div>



        </table>

      </div>
      <ModalWindow
        openModal={openModalOrder}
        setOpenModal={setOpenModalOrder}
        modalText={'Приходной ордер'}

      >
        <div  >
          <ContractOrder setOpenModalOrder={setOpenModalOrder} item={item_data} datastudent={datastudent} ></ContractOrder>
        </div>
      </ModalWindow>
      <Notification notify={notify} setNotify={setNotify} />
    </>


  );
};

export default StudentHystoryPayContent;
